<script>
export default {
	name: "DescriptionList",
	props: {
		title: {
			type: String,
		}
	},
}
</script>

<template>
	<div>
	<slot name="title">
		<h3 v-if="title">{{ title }}</h3>
	</slot>

	<dl>
		<slot/>
	</dl>

	</div>
</template>

<style scoped>
h3 {
	@apply font-medium text-gray-900 mb-2;
}

dl {
	@apply divide-y divide-gray-200 border-b border-t border-gray-200;
}
</style>